module.exports = __webpack_public_path__ + "b2680c93f4982255b685026ae573cbbd.glb";